// extracted by mini-css-extract-plugin
module.exports = {"root":"root__2H3zv","textarea":"textarea__2Q9Et","counter":"counter__2Sdev"};